"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertDimensionToSize = convertDimensionToSize;
var _illustrations = require("../tokens/illustrations");
/** Statically lookup a dimension string such as "24x24" and return it's size object { width: 24, height: 24 } */
function convertDimensionToSize(dimension) {
  const _illustrationSizes$di = _illustrations.illustrationSizes[dimension],
    width = _illustrationSizes$di[0],
    height = _illustrationSizes$di[1];
  return {
    width,
    height
  };
}